import { observer } from "mobx-react-lite";
import SmartAppStep from "../../components/apps/SmartAppStep";
import SmartAppBase from "../../components/apps/SmartAppBase";
import { Detection } from "e.sic-platform.webclient/src/components/svg/svgImageList";
import useThemeService from 'e.sic-platform.webclient/src/services/theme-service/ThemeService';
import { segmentationApp } from "../../services/apps/SmartApps";
import VideoSegmentationPlayer from "./components/VideoSegmentationPlayer";


export default observer(function VideoSegmentationPage() {
  const videoSegmentation = segmentationApp.services.videoSegmentation!;
  const {themeClass} = useThemeService();

  if (videoSegmentation.segmentationSuccessful) segmentationApp.setStep(3);

  return (
    <SmartAppBase 
      appStorage={segmentationApp}
      icon={{
        svg: Detection,
        textKey: "RunHighlightDetectionButton.run",
        className: themeClass(["icon-custom"]),
      }}
    >
      <SmartAppStep
        titleKey="videoSegmentation.viewVideo.title"
        descriptionKey="videoSegmentation.viewVideo.description"
        visible={videoSegmentation.fileId !== undefined && videoSegmentation.video !== undefined}
        step={2}
        appStorage={segmentationApp}
      >
          <VideoSegmentationPlayer videoSegmentation={videoSegmentation} />
      </SmartAppStep>
    </SmartAppBase>
  );
});
